// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("loading-back.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

rect {
  stroke-width: 1px;
  vector-effect: non-scaling-stroke;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Welcome Screen Styles */
.welcome-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.welcome-overlay-loading {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
}

.welcome-popup {
  position: relative;
  background: #000000;
  border: 1px solid #ffffff;
  border-radius: 0;
  padding: 1.5rem;
  width: 800px;
  /* max-width: 1000px; */
  max-height: 80vh;
  max-width: 90%;
  overflow-y: auto;
  box-shadow: 0 0 0 1px #ffffff;
  z-index: 10001;
  pointer-events: auto;
  scrollbar-width: thin;
  scrollbar-color: #ffffff transparent;
}

.welcome-popup::-webkit-scrollbar {
  width: 6px;
}

.welcome-popup::-webkit-scrollbar-track {
  background: transparent;
}

.welcome-popup::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  border-radius: 0;
}

.welcome-close {
  background: transparent !important;
  border: none;
  color: var(--cell-txt-color);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.welcome-close:hover {
  background: transparent !important;
  color: var(--primary-color);
}

.welcome-content {
  color: #ffffff;
  font-size: 0.9rem;
  line-height: 1.6;
}

.welcome-text {
  margin-bottom: 1.5rem;
}

.welcome-text p {
  margin: 0 0 1.2rem 0;
  color: #ffffff;
}

.welcome-loading {
  margin-top: 2rem;
}

.welcome-progress-bar {
  width: 100%;
  height: 2px;
  background: #333333;
  border: 1px solid #ffffff;
  position: relative;
  overflow: hidden;
}

.welcome-progress-fill {
  height: 100%;
  background: #ffffff;
  width: 0%;
  animation: welcome-progress 2s ease-in-out infinite;
}

@keyframes welcome-progress {
  0% {
    width: 0%;
    margin-left: 0%;
  }
  50% {
    width: 70%;
    margin-left: 0%;
  }
  100% {
    width: 100%;
    margin-left: 0%;
  }
}

/* Library Window Styles */
.library-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: auto;
}

.library-window {
  position: relative;
  background: #000000;
  border: 1px solid #ffffff;
  border-radius: 0;
  padding: 2rem;
  min-width: 600px;
  max-width: 900px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 0 0 1px #ffffff;
  z-index: 10001;
  pointer-events: auto;
  scrollbar-width: thin;
  scrollbar-color: #ffffff transparent;
}

.library-window::-webkit-scrollbar {
  width: 6px;
}

.library-window::-webkit-scrollbar-track {
  background: transparent;
}

.library-window::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  border-radius: 0;
}

.library-close {
  background: transparent !important;
  border: none;
  color: var(--cell-txt-color);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.library-close:hover {
  background: transparent !important;
  color: var(--primary-color);
}

.library-content {
  color: #ffffff;
  font-size: 0.9rem;
  line-height: 1.6;
}

.library-welcome {
  color: #ffffff;
  font-size: 0.9rem;
  margin: 0 0 1.5rem 0;
}

.library-list {
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 1rem;
}

/* Custom scrollbar for library list */
.library-list::-webkit-scrollbar {
  width: 4px;
}

.library-list::-webkit-scrollbar-track {
  background: transparent;
}

.library-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.library-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Firefox scrollbar */
.library-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.library-item {
  padding: 0.25rem 0;
  cursor: pointer;
  color: var(--primary-color);
  transition: opacity 0.2s;
}

.library-item:hover {
  opacity: 0.7;
}

.library-item-selected {
  opacity: 1;
}

.library-book-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #333;
}

.library-back {
  background: transparent !important;
  border: none;
  color: #ffffff;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: 0.75rem;
  width: auto;
  min-width: auto;
}

.library-back:hover {
  background: transparent !important;
  background-color: transparent !important;
  color: var(--primary-color);
}

.library-book-title {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: normal;
  margin: 0;
}

.library-book-content {
  color: #ffffff;
  max-height: 60vh;
  overflow-y: auto;
}

/* Custom scrollbar for book content */
.library-book-content::-webkit-scrollbar {
  width: 4px;
}

.library-book-content::-webkit-scrollbar-track {
  background: transparent;
}

.library-book-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.library-book-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Firefox scrollbar */
.library-book-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

/* Ensure RichBookContent links use primary color */
.library-book-content a,
.library-book-content .cell-popup-link {
  color: var(--primary-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yDAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,cAAc;EACd,UAAU;EACV,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,mDAAmD;AACnD;;EAEE,sCAAsC;AACxC","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\nrect {\n  stroke-width: 1px;\n  vector-effect: non-scaling-stroke;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Welcome Screen Styles */\n.welcome-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n}\n\n.welcome-overlay-loading {\n  background-image: url(\"loading-back.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: transparent;\n}\n\n.welcome-popup {\n  position: relative;\n  background: #000000;\n  border: 1px solid #ffffff;\n  border-radius: 0;\n  padding: 1.5rem;\n  width: 800px;\n  /* max-width: 1000px; */\n  max-height: 80vh;\n  max-width: 90%;\n  overflow-y: auto;\n  box-shadow: 0 0 0 1px #ffffff;\n  z-index: 10001;\n  pointer-events: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #ffffff transparent;\n}\n\n.welcome-popup::-webkit-scrollbar {\n  width: 6px;\n}\n\n.welcome-popup::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.welcome-popup::-webkit-scrollbar-thumb {\n  background-color: #ffffff;\n  border-radius: 0;\n}\n\n.welcome-close {\n  background: transparent !important;\n  border: none;\n  color: var(--cell-txt-color);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n}\n\n.welcome-close:hover {\n  background: transparent !important;\n  color: var(--primary-color);\n}\n\n.welcome-content {\n  color: #ffffff;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.welcome-text {\n  margin-bottom: 1.5rem;\n}\n\n.welcome-text p {\n  margin: 0 0 1.2rem 0;\n  color: #ffffff;\n}\n\n.welcome-loading {\n  margin-top: 2rem;\n}\n\n.welcome-progress-bar {\n  width: 100%;\n  height: 2px;\n  background: #333333;\n  border: 1px solid #ffffff;\n  position: relative;\n  overflow: hidden;\n}\n\n.welcome-progress-fill {\n  height: 100%;\n  background: #ffffff;\n  width: 0%;\n  animation: welcome-progress 2s ease-in-out infinite;\n}\n\n@keyframes welcome-progress {\n  0% {\n    width: 0%;\n    margin-left: 0%;\n  }\n  50% {\n    width: 70%;\n    margin-left: 0%;\n  }\n  100% {\n    width: 100%;\n    margin-left: 0%;\n  }\n}\n\n/* Library Window Styles */\n.library-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  pointer-events: auto;\n}\n\n.library-window {\n  position: relative;\n  background: #000000;\n  border: 1px solid #ffffff;\n  border-radius: 0;\n  padding: 2rem;\n  min-width: 600px;\n  max-width: 900px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 0 0 1px #ffffff;\n  z-index: 10001;\n  pointer-events: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #ffffff transparent;\n}\n\n.library-window::-webkit-scrollbar {\n  width: 6px;\n}\n\n.library-window::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.library-window::-webkit-scrollbar-thumb {\n  background-color: #ffffff;\n  border-radius: 0;\n}\n\n.library-close {\n  background: transparent !important;\n  border: none;\n  color: var(--cell-txt-color);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n}\n\n.library-close:hover {\n  background: transparent !important;\n  color: var(--primary-color);\n}\n\n.library-content {\n  color: #ffffff;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.library-welcome {\n  color: #ffffff;\n  font-size: 0.9rem;\n  margin: 0 0 1.5rem 0;\n}\n\n.library-list {\n  max-height: 50vh;\n  overflow-y: auto;\n  margin-bottom: 1rem;\n}\n\n/* Custom scrollbar for library list */\n.library-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.library-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.library-list::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.library-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Firefox scrollbar */\n.library-list {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.library-item {\n  padding: 0.25rem 0;\n  cursor: pointer;\n  color: var(--primary-color);\n  transition: opacity 0.2s;\n}\n\n.library-item:hover {\n  opacity: 0.7;\n}\n\n.library-item-selected {\n  opacity: 1;\n}\n\n.library-book-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #333;\n}\n\n.library-back {\n  background: transparent !important;\n  border: none;\n  color: #ffffff;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  font-size: 0.75rem;\n  width: auto;\n  min-width: auto;\n}\n\n.library-back:hover {\n  background: transparent !important;\n  background-color: transparent !important;\n  color: var(--primary-color);\n}\n\n.library-book-title {\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: normal;\n  margin: 0;\n}\n\n.library-book-content {\n  color: #ffffff;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n/* Custom scrollbar for book content */\n.library-book-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.library-book-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.library-book-content::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.library-book-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Firefox scrollbar */\n.library-book-content {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n/* Ensure RichBookContent links use primary color */\n.library-book-content a,\n.library-book-content .cell-popup-link {\n  color: var(--primary-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
